/* eslint-disable global-require,no-console */
import { addLocaleData } from 'react-intl';
import en from 'react-intl/locale-data/en';
import config from '../config/configureSettings';
import { getHistory } from './HistoryTools';

export const supportedLanguages = ['en'];
export const defaultLanguage = supportedLanguages.indexOf(process.env.defaultLanguage) >= 0 ? process.env.defaultLanguage : 'en';
const localeData = [];

if (supportedLanguages.indexOf('en')) localeData.push(...en);

export const areIntlLocalesSupported = (passedLocales) => {
  let locales = passedLocales;
  if (!locales) {
    throw new Error('[Internationalization] : locales must be supplied.');
  }

  if (typeof Intl === 'undefined') {
    console.log('[Internationalization] : window.Intl does not exist');
    return false;
  }

  if (!Array.isArray(locales)) {
    locales = [locales];
  }

  const intlConstructors = [
    Intl.DateTimeFormat,
    Intl.NumberFormat,
  ].filter((intlConstructor) => intlConstructor);

  if (intlConstructors.length === 0) {
    console.log(`[Internationalization] : window.Intl does not contain ${intlConstructors.toString()}`);
    return false;
  }

  return intlConstructors.every((intlConstructor) => {
    const supportedLocales = intlConstructor.supportedLocalesOf(locales);
    const localeSupportedForIntlFeature = supportedLocales.length === locales.length;

    if (!localeSupportedForIntlFeature) {
      console.log(`[Internationalization] : locales [${locales.toString()}] not supported for ${
        intlConstructor.name} [${supportedLocales.toString()}]`);
    }

    return localeSupportedForIntlFeature;
  });
};

export const polyfillIntl = () => {
  const applyPolyfill = () => {
    const IntlPolyfill = require('intl');
    Intl.NumberFormat = IntlPolyfill.NumberFormat;
    Intl.DateTimeFormat = IntlPolyfill.DateTimeFormat;

    require('intl/locale-data/jsonp/en');
  };

  if (!areIntlLocalesSupported(supportedLanguages)) {
    applyPolyfill();
  }
};

export const prepareLocaleData = () => {
  addLocaleData(localeData);
};

export const getLanguageFromURL = () => {
  const currentRoute = getHistory().getCurrentLocation().pathname.replace(config.basePath, '');

  return currentRoute.split('/')[0];
};
